"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OverlayMode;
(function (OverlayMode) {
    OverlayMode["manual"] = "manual";
    OverlayMode["auto"] = "auto";
})(OverlayMode = exports.OverlayMode || (exports.OverlayMode = {}));
var BackgroundEnum;
(function (BackgroundEnum) {
    BackgroundEnum["none"] = "none";
    BackgroundEnum["demo"] = "demo";
    BackgroundEnum["color"] = "color";
})(BackgroundEnum = exports.BackgroundEnum || (exports.BackgroundEnum = {}));
exports.defaultOverlayConfig = {
    resolution: 720,
    showWatermarks: true,
    background: BackgroundEnum.none,
    enableAds: true,
    mode: OverlayMode.auto
};
//# sourceMappingURL=Overlay.js.map